<template>
  <div
    class="dashboard"
    v-if="loaded"
  >
    <AppNavigation />

    <main class="main">
      <header class="header">
        <p>{{ userEmail }}</p>
        <a
          href="#"
          class="highlight underline header__logout"
          @click.prevent="goodbye"
        >
          Log af
        </a>
      </header>

      <section class="main__content">
        <div class="main__inner">
          <transition name="fade">
            <router-view :key="routerViewKey" />
          </transition>
        </div>
      </section>
    </main>
    <vue-snotify v-if="!isRefreshingToken" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppNavigation from './components/AppNavigation.vue';
import http from './services/http';

export default {
    name: 'Dashboard',
    components: {
        AppNavigation,
    },
    data() {
        return {
            loaded: false,
            isRefreshingToken: false,
            isRefreshingCounter: 0,
            routerViewKey: Math.random(),
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        userEmail() {
            if (!this.user) {
                return '';
            }

            return this.user.email;
        },
    },
    methods: {
        ...mapActions({
            loadIcons: 'icons/loadIcons',
            logout: 'auth/logout',
            refreshToken: 'auth/refreshToken',
        }),
        async handleHttpApiErrors() {
            http.interceptors.response.use((response) => {
                this.loaded = true;

                return response;
            }, async (error) => {
                try {
                    const originalRequest = error.config;

                    // eslint-disable-next-line no-underscore-dangle
                    if (error.response.status === 401 && !originalRequest._retry) {
                        // eslint-disable-next-line no-underscore-dangle
                        originalRequest._retry = true;
                        this.isRefreshingToken = true;
                        this.isRefreshingCounter += 1;
                        await this.refreshToken();

                        this.routerViewKey = Math.random();

                        if (this.isRefreshingCounter > 3) {
                            throw Error('...');
                        }

                        setTimeout(() => {
                            this.$snotify.clear();
                            this.isRefreshingToken = false;
                        }, 1000);
                    }
                } catch (err) {
                    this.logout();

                    if (this.$route.name !== 'login') {
                        this.$router.push({ name: 'login' });
                    }
                }

                return Promise.reject(error);
            });
        },
        goodbye() {
            this.logout();
            this.$router.push({ name: 'login' });
        },
    },
    async created() {
        await this.handleHttpApiErrors();

        try {
            await this.loadIcons();
        } catch (error) {
            //
        }
    },
};
</script>

<style lang="scss" scoped>
.dashboard {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.main {
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  &__content {
    background: $content-background;
    flex-grow: 1;
    border-top: 1px solid $gray;
    overflow: auto;
    height: calc(100% - #{$headerHeight});
    position: relative;
  }
  &__inner {
    padding: 40px;
    max-width: 1500px;
  }
}
.header {
  height: $headerHeight;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 100px;

  &__logout {
      margin-left: 50px;
  }
}
</style>
